var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.652,
    height: 39,
    viewBox: "0 0 46.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8945",
    "data-name": "Group 8945",
    transform: "translate(-1675 -464.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload-solid",
    d: "M18.943,5.728V18.4a1.926,1.926,0,0,1-2.1,1.67,1.926,1.926,0,0,1-2.1-1.67V5.728L9.9,9.559a2.511,2.511,0,0,1-2.98,0,1.441,1.441,0,0,1,0-2.364L15.345.514a2.513,2.513,0,0,1,2.98,0L26.743,7.2a1.441,1.441,0,0,1,0,2.364,2.511,2.511,0,0,1-2.98,0ZM4.209,18.4h8.419c0,1.845,1.885,3.34,4.209,3.34s4.209-1.5,4.209-3.34h8.419c2.324,0,4.207,1.5,4.209,3.34v1.67c0,1.844-1.886,3.339-4.209,3.34H4.209C1.886,26.744,0,25.25,0,23.406v-1.67C0,19.892,1.886,18.4,4.209,18.4Zm24.2,5.428a1.444,1.444,0,0,0,1.579-1.253,1.444,1.444,0,0,0-1.579-1.253,1.444,1.444,0,0,0-1.579,1.253,1.135,1.135,0,0,0,.461.887,1.8,1.8,0,0,0,1.123.361Z",
    transform: "translate(1681.875 470.659)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4453",
    "data-name": "Rectangle 4453",
    transform: "translate(1675 464.5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.1469ea860b921c62b6ad2f1823cc8fad.svg";
export { ForwardRef as ReactComponent };